import {ReactElement, ReactNode} from "react";
import {StyledContainer} from "@/shared/StyledComponents";
import {Button, ButtonProps} from "@mui/material";
import {PD_MD, PD_XLG2} from "@/shared/dimens";

export function LargeButton(props: ButtonProps): ReactElement {
  return <Button {...props} style={{
    fontSize: "100%",
    padding: `${PD_MD}px ${PD_XLG2}px`,
    borderRadius: 0,
    ...props.style,
  }}/>
}

export function SectionContainer(props: { children?: ReactNode, style?: any }): ReactElement {
  return <StyledContainer style={{padding: "5% 6%", ...props.style}}>
    {props.children}
  </StyledContainer>
}
